import axios from "axios";

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// export const apiFormData = axios.create({
//   baseURL: API_BASE_URL,
//   headers: {
//     "Content-Type": "multipart/form-data",
//   },
//   withCredentials: true,
// });
